import _ from 'lodash'
import Backbone from 'backbone'
import JsonStreamer from 'scoreboard/components/json-streamer'
import errorHandler from 'scoreboard/components/error-handler'
import {isOffline} from 'scoreboard/components/xhr'

/**
 * Handles a stream of objects returned from the server.  Takes an object that
 * will append the following properties:
 * {
 *  metadata:    //the metadata returned from the server
 *  results:     //the node stream
 *  initialData: //the initial chunk of data received from the stream
 * }
 * The options object is passed along to the stream and will be used to send any
 * data to the server for processing.  The options arguments supports standard
 * 'context', 'success', 'error' options available to the jQuery ajax function,
 * and in addition provides a callback function 'parseForm' that is called when
 * first receiving the metadata of the stream
 *
 * @param {Backbone.Model} model
 * Returns a promise that is resolved once the end of the stream has been reached
 */
function stream(model, options) {
	var opts = options || {}

	var def = Backbone.$.Deferred()
	var stream = new JsonStreamer()

	// abort previous pending request if any not finished
	_.invoke(model._def, 'reject', model, null, model._def)
	_.result(model._listStream, 'abort')
	model._listStream = stream
	model._def = def

	//resolve the fetch once data has been processed or stream has signaled
	//end, whichever comes first
	var resolve = function() {
		if (def.state() != 'pending') return
		if (opts.success) {
			var ctx = opts.context || this
			opts.success.call(ctx, this)
		}
		def.resolve(this, def)
	}.bind(model)

	//capture the metadata regarding the execution
	stream.on('data', function(key, value) {
		if (opts.parseForm) {
			opts.parseForm.call(this, key, value)
		}
	}.bind(model))

	model.initialData = []
	stream.once('stream', function(streamer) {
		model.initialData = []
		streamer.on('data', chunk => {
			// if the promise was aborted before we finished then the data is
			// stale and ignore it
			if (def.state() == 'rejected') return

			if (opts.parseChunk) {
				opts.parseChunk.call(this, chunk)
			}

			//make data available
			if (_.isEmpty(model.initialData)) {
				model.initialData = [].concat(chunk)
				resolve()
			} else {
				//#10935 add chunk to previously streamed results since reports
				//are cached unlike other domain objects
				model.initialData = model.initialData.concat(chunk)
			}
		})
		//store reference to chunked stream to be added to the list that is
		//created after parsing the metadata returned
		model.stream(streamer)
		streamer.once('end', resolve)
	})

	var error = opts.error
	opts.error = err => {
		const xhr = err.xhr
		//if it's offline bypass custom error for global offline error message
		if (isOffline(xhr) || !_.isFunction(error)) {
			errorHandler(xhr)
		} else {
			error(model, xhr)
		}
		def.reject(model, xhr, def)
	}

	stream.start(opts)
	model._streamPromise = def
	model.trigger('request', model, def, opts)
	return def
}

export default stream

stream.__filename__ = 'reports/common/list-streamer.js'
